import { render, staticRenderFns } from "./SitckyButton.vue?vue&type=template&id=3406f0aa&"
import script from "./SitckyButton.vue?vue&type=script&lang=js&"
export * from "./SitckyButton.vue?vue&type=script&lang=js&"
import style0 from "./SitckyButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports